












































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HamburgerButton extends Vue {
    active: boolean = false;

    toggleMenu() {
        this.active = !this.active;
        //@ts-ignore
        this.$root.navigationIsVisible = this.active;
    }
}
